module.exports = __webpack_public_path__ + "img/banner-principal.def90220.png";